// React
import React, { Fragment } from "react";

// Routing
import { Link } from "react-router-dom";

// Ant Design Components
import { Popconfirm } from "antd";

// Custom UI Components
import H3Text from "@Uilib/h3Text";

// Helpers
import Helpers from "@Apis/helpers";

export const getColumnState = ({
  selectPaymentTenant,
  MONEY,
  unLinkPayment,
  getPaymentOutgoingById,
  user,
  selectedPaymentId,
  callback,
  paymentType,
  screen,
  unlinkIncomingPayment,
  selectedPaymentOutgoing,
}) => {
  const columns = {
    columns: [
      {
        title: "",
        responsive: ["xs"],
        render: (item) => {
          return (
            <div className="mobile-list__item">
              <Link
                to={`/approval?type=po&id=${item?.grn_details?.po_id}${
                  selectPaymentTenant ? `&tenant_id=${selectPaymentTenant}` : ""
                }`}
              >
                <H3Text
                  text={`REFERENCE NUMBER: ${item?.grn_details?.po_number}`}
                  className="mobile-list__item-number"
                />
              </Link>
              <H3Text
                text={`GRN TOTAL - ${MONEY(
                  item?.grn_details?.grn_grand_total || "0"
                )}`}
                className="mobile-list__item-info"
              />
              <H3Text
                text={`LINKED AMOUNT - ${MONEY(
                  item?.total_linked_amount || 0
                )})`}
                className="mobile-list__item-info"
              />
            </div>
          );
        },
      },
      {
        title: "GRN NUMBER",
        responsive: ["sm", "md", "lg", "xxl"],
        render: (text, record) => {
          return (
            <Link
              to={`/purchase/goods-receiving/view/${record?.grn_details?.grn_id}`}
              target="_blank"
            >
              <H3Text
                text={
                  <div>
                    {record?.grn_details?.grn_number}
                    <div className="" />
                  </div>
                }
                className="payment__po_no"
              />
            </Link>
          );
        },
      },
      {
        title: "GRN TOTAL",
        responsive: ["sm", "md", "lg", "xxl"],
        render: (text, record) =>
          MONEY(record?.grn_details?.grn_grand_total || "0"),
      },
      {
        title: "LINKED AMOUNT",
        responsive: ["sm", "md", "lg", "xxl"],
        render: (text, record) => MONEY(record?.total_linked_amount || 0),
      },
    ],
    apInvoiceColumns: [
      {
        title: "",
        responsive: ["xs"],
        render: (item) => {
          return (
            <div className="mobile-list__item">
              <H3Text
                text={`GRN ID - ${item?.ap_invoice_details?.ap_invoice_id}`}
                className="mobile-list__item-info"
              />
              <Link
                to={`/approval?type=po&id=${
                  item?.ap_invoice_details?.ap_invoice_id
                }${
                  selectPaymentTenant ? `&tenant_id=${selectPaymentTenant}` : ""
                }`}
              >
                <H3Text
                  text={`REFERENCE NUMBER: ${item?.ap_invoice_details?.ap_invoice_number}`}
                  className="mobile-list__item-number"
                />
              </Link>
              <H3Text
                text={`TOTAL - ${MONEY(
                  item?.ap_invoice_details?.grand_total || "0"
                )}`}
                className="mobile-list__item-info"
              />
              <H3Text
                text={`LINKED AMOUNT - ${MONEY(
                  item?.total_linked_amount || 0
                )})`}
                className="mobile-list__item-info"
              />
            </div>
          );
        },
      },
      {
        title: "AP INVOICE #",
        responsive: ["sm", "md", "lg", "xxl"],
        render: (text, record) => {
          return (
            <Link
              to={`/purchase/account-payable-invoice/view/${record?.ap_invoice_details?.ap_invoice_id}`}
              target="_blank"
            >
              <H3Text
                text={
                  <div>
                    {record?.ap_invoice_details?.ap_invoice_number}
                    <div className="" />
                  </div>
                }
                className="payment__po_no"
              />
            </Link>
          );
        },
      },
      {
        title: "TOTAL",
        responsive: ["sm", "md", "lg", "xxl"],
        render: (text, record) =>
          MONEY(record?.ap_invoice_details?.grand_total || "0"),
      },
      {
        title: "LINKED AMOUNT",
        responsive: ["sm", "md", "lg", "xxl"],
        render: (text, record) => MONEY(record?.total_linked_amount || 0),
      },
      {
        title: "",
        responsive: ["sm", "md", "lg", "xxl"],
        render: (record) => {
          return (
            <Fragment>
              <Popconfirm
                placement="topRight"
                title="Are you sure to unlink this payment? It will added back to as unused debits for this vendor."
                onConfirm={() =>
                  handleUnLinkPayment({
                    paymentId:
                      record?.ap_invoice_details?.payments?.[0]?.grn_payment_id,
                    unLinkPayment,
                    getPaymentOutgoingById,
                    user,
                    selectedPaymentId,
                    callback,
                    paymentType,
                    screen,
                    unlinkIncomingPayment,
                  })
                }
                okText="Yes"
                cancelText="No"
                disabled={
                  !Helpers.getPermission(
                    Helpers.permissionEntities.CUSTOMER_PAYMENTS,
                    Helpers.permissionTypes.UPDATE,
                    user
                  )
                }
              >
                <div className="payment-unlink-button">Unlink Payment</div>
              </Popconfirm>
            </Fragment>
          );
        },
      },
    ],
    poColumns: [
      {
        title: "PO NUMBER",
        responsive: ["sm", "md", "lg", "xxl"],
        render: (text, record) => (
          <Link to={`/approval?type=po&id=${record?.po_id}`} target="_blank">
            <H3Text
              text={
                <div>
                  {record?.po_number}
                  <div className="" />
                </div>
              }
              className="payment__po_no"
            />
          </Link>
        ),
      },
      {
        title: "PO TOTAL",
        responsive: ["sm", "md", "lg", "xxl"],
        render: (text, record) => MONEY(record?.po_grand_total || "0"),
      },
      {
        title: "LINKED AMOUNT",
        responsive: ["sm", "md", "lg", "xxl"],
        render: (text, record) => MONEY(selectedPaymentOutgoing?.amount || 0),
      },
    ],
    cnColumns: [
      {
        title: "CN NUMBER",
        responsive: ["sm", "md", "lg", "xxl"],
        render: (text, record) => {
          return (
            <Link
              to={`/sales/credit-note/view/${record?.credit_note_details?.cn_id}`}
              target="_blank"
            >
              <H3Text
                text={
                  <div>
                    {record?.credit_note_details?.credit_note_number}
                    <div className="" />
                  </div>
                }
                className="payment__po_no"
              />
            </Link>
          );
        },
      },
      {
        title: "CN TOTAL",
        responsive: ["sm", "md", "lg", "xxl"],
        render: (text, record) =>
          MONEY(record?.credit_note_details?.cn_grand_total || "0"),
      },
      {
        title: "LINKED AMOUNT",
        responsive: ["sm", "md", "lg", "xxl"],
        render: (text, record) => MONEY(record?.total_linked_amount || 0),
      },
      {
        title: "",
        responsive: ["sm", "md", "lg", "xxl"],
        render: (record) => {
          return (
            <Fragment>
              <Popconfirm
                placement="topRight"
                title="Are you sure to unlink this payment? It will added back to as unused credits for this vendor."
                onConfirm={() =>
                  handleUnLinkPayment({
                    paymentId:
                      record?.credit_note_details?.credit_note_payments?.[0]
                        ?.grn_payment_id,
                    unLinkPayment,
                    getPaymentOutgoingById,
                    user,
                    selectedPaymentId,
                    callback,
                    paymentType,
                    screen,
                    unlinkIncomingPayment,
                  })
                }
                okText="Yes"
                cancelText="No"
                disabled={
                  !Helpers.getPermission(
                    Helpers.permissionEntities.CUSTOMER_PAYMENTS,
                    Helpers.permissionTypes.UPDATE,
                    user
                  )
                }
              >
                <div className="payment-unlink-button">Unlink Payment</div>
              </Popconfirm>
            </Fragment>
          );
        },
      },
    ],
    dnColumns: [
      {
        title: "DN NUMBER",
        responsive: ["sm", "md", "lg", "xxl"],
        render: (text, record) => {
          return (
            <Link
              to={`/purchase/debit-note/view/${record?.debit_note_details?.dn_id}`}
              target="_blank"
            >
              <H3Text
                text={
                  <div>
                    {record?.debit_note_details?.debit_note_number}
                    <div className="" />
                  </div>
                }
                className="payment__po_no"
              />
            </Link>
          );
        },
      },
      {
        title: "DN TOTAL",
        responsive: ["sm", "md", "lg", "xxl"],
        render: (text, record) =>
          MONEY(record?.debit_note_details?.dn_grand_total || "0"),
      },
      {
        title: "LINKED AMOUNT",
        responsive: ["sm", "md", "lg", "xxl"],
        render: (text, record) => MONEY(record?.total_linked_amount || 0),
      },
      {
        title: "",
        responsive: ["sm", "md", "lg", "xxl"],
        render: (record) => {
          return (
            <Fragment>
              <Popconfirm
                placement="topRight"
                title="Are you sure to unlink this payment? It will added back to as unused debits for this vendor."
                onConfirm={() =>
                  handleUnLinkPayment({
                    paymentId:
                      record?.debit_note_details?.debit_note_payments?.[0]
                        ?.invoice_payment_id,
                    unLinkPayment,
                    getPaymentOutgoingById,
                    user,
                    selectedPaymentId,
                    callback,
                    paymentType,
                    screen,
                    unlinkIncomingPayment,
                  })
                }
                okText="Yes"
                cancelText="No"
                disabled={
                  !Helpers.getPermission(
                    Helpers.permissionEntities.CUSTOMER_PAYMENTS,
                    Helpers.permissionTypes.UPDATE,
                    user
                  )
                }
              >
                <div className="payment-unlink-button">Unlink Payment</div>
              </Popconfirm>
            </Fragment>
          );
        },
      },
    ],
  };
  return columns;
};

export function handleUnLinkPayment({
  paymentId,
  unLinkPayment,
  getPaymentOutgoingById,
  user,
  selectedPaymentId,
  callback,
  paymentType,
  screen,
  unlinkIncomingPayment,
}) {
  if (screen) {
    unlinkIncomingPayment(paymentId, () => {
      getPaymentOutgoingById(
        Helpers.getTenantEntityPermission(
          user?.user_tenants,
          Helpers.permissionEntities.VENDOR_PAYOUT,
          Helpers.permissionTypes.READ
        ).join(","),
        selectedPaymentId,
        () => {},
        paymentType
      );
      callback();
    });
  } else {
    unLinkPayment(paymentId, () => {
      getPaymentOutgoingById(
        Helpers.getTenantEntityPermission(
          user?.user_tenants,
          Helpers.permissionEntities.VENDOR_PAYOUT,
          Helpers.permissionTypes.READ
        ).join(","),
        selectedPaymentId,
        () => {},
        paymentType
      );
      callback();
    });
  }
}

export function handleFileChange({
  fileListData,
  updateAttachment,
  selectedPaymentOutgoing,
  getAttachmentById,
  setIsGetAttachment,
  setFileList,
}) {
  const fileList = fileListData?.fileList?.map((item) => ({
    ...item,
    url: item?.response?.response?.location || item?.url,
  }));
  const attachments = fileList?.map((attachment) => ({
    url: attachment?.response?.response?.location || attachment?.url,
    type: attachment.type,
    name: attachment.name,
    uid: attachment.uid,
  }));
  if (fileListData?.file.status === "done") {
    const payload = {
      entity_id: selectedPaymentOutgoing?.payment_id,
      entity_name: "payment_outgoing",
      attachments,
    };
    updateAttachment(payload, () => {
      getAttachmentById(
        selectedPaymentOutgoing?.payment_id,
        "payment_outgoing",
        () => {
          setIsGetAttachment(true);
        }
      );
    });
  }
  if (fileListData?.file.status === "removed") {
    const payload = {
      entity_id: selectedPaymentOutgoing?.payment_id,
      entity_name: "payment_outgoing",
      attachments,
    };
    updateAttachment(payload, () => {
      getAttachmentById(
        selectedPaymentOutgoing?.payment_id,
        "payment_outgoing",
        () => {
          setIsGetAttachment(true);
        }
      );
    });
  }
  setFileList(attachments.length > 0 ? attachments : []);
}

export const HideAdhocApprovals = (selectedPaymentOutgoing) => {
  if (selectedPaymentOutgoing?.workflow_steps) {
    const steps = Object.values(
      selectedPaymentOutgoing?.workflow_steps
    )?.filter((step) => step !== null);
    const pendingSteps = steps?.filter((step) => step?.status === "PENDING");
    return steps.length < 10 && pendingSteps.length === steps.length;
  }
  return false;
};

export const getColumns = ({
  tableColumns,
  user,
  selectedPaymentOutgoing,
  unLinkPayment,
  getPaymentOutgoingById,
  selectedPaymentId,
  callback,
  paymentType,
  screen,
  unlinkIncomingPayment,
}) => {
  if (
    Helpers.getPermission(
      Helpers.permissionEntities.VENDOR_PAYOUT,
      Helpers.permissionTypes.UPDATE,
      user
    )
  ) {
    return [
      ...tableColumns,
      {
        title: "",
        responsive: ["sm", "md", "lg", "xxl"],
        render: (record) => (
          <Fragment>
            {!selectedPaymentOutgoing?.zoho_bill_payment_id &&
            !selectedPaymentOutgoing?.tally_bill_payment_number ? (
              <Popconfirm
                placement="topRight"
                title="Are you sure to unlink this payment? It will added back to as unused credits for this vendor."
                onConfirm={() =>
                  handleUnLinkPayment({
                    paymentId:
                      record?.grn_details?.grn_payments?.[0]?.grn_payment_id,
                    unLinkPayment,
                    getPaymentOutgoingById,
                    user,
                    selectedPaymentId,
                    callback,
                    paymentType,
                    screen,
                    unlinkIncomingPayment,
                  })
                }
                okText="Yes"
                cancelText="No"
                disabled={
                  !Helpers.getPermission(
                    Helpers.permissionEntities.VENDOR_PAYOUT,
                    Helpers.permissionTypes.UPDATE,
                    user
                  )
                }
              >
                <div className="payment-unlink-button">Unlink Payment</div>
              </Popconfirm>
            ) : (
              <H3Text text="Payments imported from Tally/Zoho cannot be updated" />
            )}
          </Fragment>
        ),
      },
    ];
  }
  if (
    selectedPaymentOutgoing?.zoho_bill_payment_id ||
    selectedPaymentOutgoing?.tally_bill_payment_number
  ) {
    return [
      ...tableColumns,
      {
        title: "",
        responsive: ["sm", "md", "lg", "xxl"],
        render: () => (
          <Fragment>
            <H3Text text="Payments imported from Tally/Zoho cannot be updated" />
          </Fragment>
        ),
      },
    ];
  }
  return tableColumns;
};

export const getRequiredColumns = ({
  screen,
  selectedPaymentOutgoing,
  dnColumns,
  tableColumns,
  cnColumns,
  apInvoiceColumns,
}) => {
  if (screen) {
    return selectedPaymentOutgoing?.linked_debit_notes
      ? dnColumns
      : tableColumns;
  }
  return selectedPaymentOutgoing?.linked_credit_notes
    ? cnColumns
    : selectedPaymentOutgoing?.linked_ap_invoices
    ? apInvoiceColumns
    : tableColumns;
};
